import { ID } from '../../utils/codecUtils';
import { IntegrationCredentialSecret } from '../models/integrationCredential';
import { integrationCredentialTestResultSchema } from '../models/integrationCredential.schema';
import { testExistingIntegrationCredentialPayloadSchema } from './testExisting.schema';

export type TestExistingIntegrationCredentialPayload = {
  secret: IntegrationCredentialSecret;
};

/** Tests an already stored credential, optionally overriding parts of its secret. */
export const testExisting = (
  integrationCredentialId: ID,
  payload: TestExistingIntegrationCredentialPayload
) => {
  return {
    endpoint: `/integration_credentials/${integrationCredentialId}/test`,
    method: 'POST',
    payload,
    responseSchema: integrationCredentialTestResultSchema,
    payloadSchema: testExistingIntegrationCredentialPayloadSchema,
  } as const;
};
